import gql from 'graphql-tag';

export const DEAL_EVENT_ACTIVITY_FRAGMENT = gql`
  fragment DealEventActivityFields on DealEventActivityViewModel {
    id
  }
`;
